var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import ECharts from '../ECharts';
import Tooltip from '../components/Tooltip';
import Legend from '../components/Legend';
import Radar from '../components/Radar';
import RadarLine from '../series/RadarLine';
import { is, isSeries } from '../utils';
import { EChartsContext } from '../constants';
function RadarChart(_a, ref) {
    var { name, data = [], tooltip = true, legend = true, children } = _a, props = __rest(_a, ["name", "data", "tooltip", "legend", "children"]);
    function renderDefaultRadar() {
        const indicator = data.map(([name, max]) => ({ name, max }));
        return React.createElement(Radar, { indicator: indicator });
    }
    function renderDefaultRadarLine() {
        return React.createElement(RadarLine, { name: name, value: data.map(([_, __, value]) => value) });
    }
    const components = Children.toArray(children);
    const series = components.filter(isSeries);
    return (React.createElement(EChartsContext.Provider, { value: { chartType: 'radar', dataName: name } },
        React.createElement(ECharts, Object.assign({ ref: ref }, props),
            !components.find(comp => is(comp, 'radar')) && renderDefaultRadar(),
            !components.find(comp => is(comp, 'radarLine')) && renderDefaultRadarLine(),
            tooltip && React.createElement(Tooltip, null),
            legend && React.createElement(Legend, { icon: "rect", itemWidth: 14 }),
            components.map((child) => {
                if (data.length && isSeries(child) && !child.props.data) {
                    const serieIndex = series.indexOf(child);
                    return cloneElement(child, { data: data.map(d => d[serieIndex + 2]) });
                }
                return child;
            }))));
}
if (process.env.NODE_ENV !== 'production') {
    RadarChart.displayName = 'RadarChart';
}
export default React.forwardRef(RadarChart);
//# sourceMappingURL=RadarChart.js.map